export enum PortalRequestsListSortProp {
    PortalRequestStatus = 'PortalRequestStatus',
    PortalRequestId = 'PortalRequestId',
    RequestDate = 'RequestDate',
    AnswerDate = 'AnswerDate',
}